import { User } from '@/types/auth';
import { hasPermission, Permission } from './permissions';

export function hasTraderFullAccess(
  user: User | null | undefined,
): boolean {
  return hasPermission(user, Permission.TRADER_OPERATIONS_FULL);
}
